import SearchRenderer from './renderer';

export const searchPlugin = {
  beforeRender({ headerRenderers, header, params }) {
    header.actions.children.push({
      type: 'searchRenderer',
      data: {
        label: 'Search',
        id: 'search',
        breakpoints: params.breakpoints,
        isAlwaysVisible: params.isAlwaysVisible,
        messageBusTopic: params.messageBusTopic,
      },
    });

    headerRenderers.push(SearchRenderer);
  },
};
